import type { PromptResolve } from '@ur-solutions/react-components'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import { RegularModal, TextArea } from '@/components_deprecated'
import { Field, Form } from '@/modules/companies'
import { notEmptyValidation } from '@/utils/forms'
import { useRef, useState } from 'react'
import { Attachments, type AttachmentsRef } from '@/modules/issues'
import type { Attachment, FileAttachment } from '@/utils/hooks'

interface ReceiptInfringementModalProps {
  initialData?: { reason?: string; attachments?: Attachment[] }
  onSubmit: PromptResolve<{
    reason: string
    attachmentsAdd: Omit<FileAttachment, 'id'>[]
    attachmentsRemove: string[]
  } | null>
}

export const ReceiptInfringementModal: React.FC<
  ReceiptInfringementModalProps
> = ({ onSubmit, initialData }) => {
  const translations = useTranslate({
    reason: 'common.reason',

    required: 'common.required',
    receiptInfringement: 'infringements.receipt',
  })
  const [attachmentsAdd, setAttachmentsAdd] = useState<
    Omit<FileAttachment, 'id'>[]
  >([])
  const [attachmentsRemove, setAttachmentsRemove] = useState<string[]>([])
  const attachmentsRef = useRef<AttachmentsRef>(null)

  const {
    formValues: form,
    formErrors: errors,
    updateForm,
    formValid,
  } = useForm<{ reason: string }>({
    values: {
      reason: initialData?.reason || '',
    },
    validators: {
      reason: value =>
        !notEmptyValidation(value) ? translations.required : null,
    },
  })

  function handleAttachmentsUpdate(add: FileAttachment[], remove: string[]) {
    setAttachmentsAdd(
      add.map(attachment => ({
        name: attachment.name,
        file: attachment.file,
      }))
    )
    setAttachmentsRemove(remove)
  }

  return (
    <RegularModal
      title={translations.receiptInfringement}
      width="600px"
      onCancel={() => onSubmit(null)}
      onSubmit={() =>
        onSubmit({
          reason: form.reason,
          attachmentsAdd,
          attachmentsRemove,
        })
      }
      submitDisabled={!form.reason || !formValid}
      submitText={translations.receiptInfringement}
    >
      <Form>
        <Field>
          <label>{translations.reason}</label>
          <TextArea
            width="550px"
            value={form.reason}
            error={errors.reason}
            onChange={value => updateForm({ reason: value })}
          />
        </Field>
        <Attachments
          ref={attachmentsRef}
          editing={true}
          attachments={initialData?.attachments || []}
          onUpdate={handleAttachmentsUpdate}
        />
      </Form>
    </RegularModal>
  )
}
